import { render, staticRenderFns } from "./ProductionReport.vue?vue&type=template&id=4f481a12&scoped=true"
import script from "./ProductionReport.vue?vue&type=script&lang=js"
export * from "./ProductionReport.vue?vue&type=script&lang=js"
import style0 from "./ProductionReport.vue?vue&type=style&index=0&id=4f481a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f481a12",
  null
  
)

export default component.exports